import api from "./ApiClient";
let csrfInitPromise = null;
let csrfLastAt = 0;

const CSRF_REFRESH_MS = 10 * 60 * 1000;

export async function refreshCsrfHeader() {
    const res = await api.get("/csrf-token");
    const token = res.data?.csrf_token;
    
    if (token) {
        api.defaults.headers.common["X-CSRF-TOKEN"] = token;
    }
    return token;
}

export async function initCsrfOnce({ force = false } = {}) {
    const now = Date.now();
    const isFresh = now - csrfLastAt < CSRF_REFRESH_MS;
  
    if (!force && csrfInitPromise && isFresh) return csrfInitPromise;
  
    csrfInitPromise = (async () => {
      await api.get("/sanctum/csrf-cookie");
      await refreshCsrfHeader();
      csrfLastAt = Date.now();
      return true;
    })();
  
    return csrfInitPromise;
}
  
export function resetAuthClientSide() {
    csrfInitPromise = null;
    csrfLastAt = 0;
    delete api.defaults.headers.common["X-CSRF-TOKEN"];
    delete api.defaults.headers.common["Authorization"];
}
  
let interceptorAttached = false;

export function attachAuthInterceptors() {
  if (interceptorAttached) return;
  interceptorAttached = true;

  api.interceptors.response.use(
    (res) => res,
    async (err) => {
      const status = err?.response?.status;
      
      if (status === 419) {
        const original = err.config;
        if (!original || original.__retried419) return Promise.reject(err);

        try {
          original.__retried419 = true;
          await initCsrfOnce({ force: true });
          return api.request(original);
        } catch (e) {
          return Promise.reject(err);
        }
      }

      return Promise.reject(err);
    }
  );
}
export async function initCsrf() {
    await api.get("/sanctum/csrf-cookie");
    await refreshCsrfHeader();
}

export async function requestNonce(walletAddress) {
    const res = await api.post("/api/auth/nonce", {
        address: walletAddress
    });
    return res.data;
}

export async function verifySignature(walletAddress, signature) {
    await initCsrfOnce();
    const res = await api.post("/api/auth/verify", {
        address: walletAddress,
        signature
    });
    const token = res.data?.data?.token;
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    return res.data;
}

export async function logout() {
    await initCsrfOnce();
    const res = await api.post("/api/logout");
    resetAuthClientSide();
    return res.data;
}

export async function submitReferral(payload) {
    await initCsrfOnce();
    const res = await api.post("/api/referral/submit", payload);
    return res.data;
}

export async function submitReferralBuy(payload) {
    await initCsrfOnce();
    const res = await api.post("/api/referral/buy", payload);
    return res.data;
}

export async function addProposal(payload) {
    await initCsrfOnce();
    const res = await api.post("/api/addproposal", payload);
    return res.data;
}